export default class UserContext {
  constructor (data = {}) {
    this.formId = data.form_id || null
    this.appointmentType = data.appointment_type || null
    this.appointmentId = data.appointment_id || null
    this.patientType = data.patient_type || null
  }
}
